// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import AudereGlobalMuiOverrides from "./AudereGlobalMuiOverrides";
import ExternalGlobalMuiOverrides from "../config/ExternalGlobalMuiOverrides";
import { createMuiTheme } from "@material-ui/core";
import getSassStyle from "./sassStyle";

export const getGlobalTheme = (overrides?: any) => {
  overrides = overrides || {};
  const themeProps = {
    palette: {
      primary: {
        main: getSassStyle().primarycolor,
        light: getSassStyle().primarylight,
        dark: getSassStyle().primarydark,
      },
      secondary: { main: "#fafafa", light: "#fff", dark: "#c7c7c7" },
      background: { default: "#ffffff" },
      text: {
        primary: "#212b32",
      },
      ...overrides.palette,
    },

    typography: {
      button: {
        textTransform: "none",
      },
      h1: {
        fontSize: 24,
        marginBottom: "1rem",
      },
      body2: {
        fontSize: 17,
      },
      fontSize: 17,
      htmlFontSize: 17,
      ...overrides.typography,
    },

    overrides: {
      ...AudereGlobalMuiOverrides,
      ...ExternalGlobalMuiOverrides,
      ...overrides.overrides,
    },

    props: {
      ...overrides.props,
    },
  };
  return createMuiTheme(themeProps);
};
